import type { JsonObject } from "@/domains/common/types";
import type { Uuid } from "@/domains/global/identifiers";
import type {
  AssistantRoutineKind,
  AssistantRoutineModelData,
  AssistantRoutineStatus,
} from "@/store/assistant/types";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind, type SyncUpdateValue } from "@/store/sync/types";
import type { WithAppStore } from "@/store/types";
import { computed, makeObservable, observable } from "mobx";

export class AssistantRoutineObservable extends BaseSyncModel<AssistantRoutineModelData> {
  public modelKind = SyncModelKind.AssistantRoutine;

  constructor({
    id,
    data,
    store,
  }: { id: Uuid; data: SyncUpdateValue<AssistantRoutineModelData> } & WithAppStore) {
    super({ id, data, store });

    makeObservable(this, {
      modelKind: observable,
      assistantId: computed,
      label: computed,
      description: computed,
      kind: computed,
      status: computed,
      fixed: computed,
      configJson: computed,
      nextRunAt: computed,
      lastRunAt: computed,
      createdAt: computed,
      updatedAt: computed,
    });
  }

  get assistantId(): Uuid {
    return this.modelData.assistant_id;
  }

  get label(): string {
    return this.modelData.label;
  }

  get description(): string {
    return this.modelData.description;
  }

  get kind(): AssistantRoutineKind {
    return this.modelData.kind;
  }

  get status(): AssistantRoutineStatus {
    return this.modelData.status;
  }

  get fixed(): boolean {
    return this.modelData.fixed;
  }

  get configJson(): JsonObject {
    return this.modelData.config_json;
  }

  get nextRunAt(): string | null {
    return this.modelData.next_run_at;
  }

  get lastRunAt(): string | null {
    return this.modelData.last_run_at;
  }

  get createdAt(): string {
    return this.modelData.created_at;
  }

  get updatedAt(): string {
    return this.modelData.updated_at;
  }
}
